import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/service/auth.service';
import { toCamelCase } from '@shared/utils/string-case-manipulation';
import { User } from '../auth/model/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginComponentGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    // state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const projectName = route.paramMap.get('project') || '';

    return from(this.authService.isLoggedIn(projectName)).pipe(
      map((response) => {
        if (response.data) {
          this.authService.user = toCamelCase(response.data) as User;
          this.router.createUrlTree(['dashboard']);
        }
        return true;
      }),
      catchError(() => {
        return of(true);
      }),
    );
  }
}
